<template>
  <div id="tvPackage">
    <section class="services" id="package">
      <div class="container">
        <div class="row">
          <div class="col-md-10">
            <div class="title">
              <h3>БАГЦ ҮЙЛЧИЛГЭЭ</h3>
              <div class="underline"></div>
              <h3>ИНТЕРНЕТ + ТЕЛЕВИЗ + СУУРИН УТАС</h3>
              <p>
                75см бүхий нэг антенаар интернет, телевиз, суурин утасны үйлчилгээг авах боломжтой.
                Интернетийн төхөөрөмжид телевизийн хүлээн авагч болон суурин утасны төхөөрөмүүд үнэгүй дагалдана.
              </p>
              <img src="../assets/img/package.jpg" alt />
            </div>
            <!--/.title-->
          </div>
          <div class="w-100"></div>
          <div class="col-md-4 wow animate fadeInUp">
            <div class="service_single">
              <img src="../assets/img/icon/package.png" alt />
              <h4>БАГЦ үйлчилгээ:*</h4>
              <p>Энэхүү гурвалсан үйлчилгээг бид Монголсат ХХК-тай хамтран танд хүргэж байгаа бөгөөд Телевизийн үйлчилгээ нь Монголсат ХХК-н FREE VIEW TV үйлчилгээ юм.</p>
            </div>
            <!--/.service_single-->
          </div>
          <div class="col-md-4 wow animate fadeInUp" data-wow-delay="0.2s">
            <div class="service_single">
              <img src="../assets/img/icon/settings02.png" alt />
              <h4>Суурилуулалт:*</h4>
              <p>Интернетийн төхөөрөмжийн анхны суурилуулалтын заавар, зөвлөгөөг манай компаний 7100 5555 дугаараас өдөр бүр 9:00 - 20:00 цагийн хооронд авах боломжтой.</p>
            </div>
            <!--/.service_single-->
          </div>
          <div class="col-md-4 wow animate fadeInUp" data-wow-delay="0.4s">
            <div class="service_single">
              <img src="../assets/img/icon/pay02.png" alt />
              <h4>Үнэ тариф:*</h4>
              <p>Телевийн үйлчилгээ нь сарын суурь хураамжгүй бөгөөд та 80+ суваг үнэгүй үзэх боломжтой. Интернетийн үйлчилгээг та өөрийн хэрэгцээндээ тохируулах DATA багцуудаас сонголтоо хийгээрэй..</p>
            </div>
            <!--/.service_single-->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "tvPackage",
  components: {}
};
</script>